
// apenas números nos campos
function onlyNumbers(e, setFieldValue, fieldName) {
  const { value } = e.target;

  // Substituir vírgula por ponto
  if (e.key === ',') {
    e.preventDefault();
    setFieldValue(fieldName, `${value}.`);
    return;
  }

  // Permitir apenas números, ponto, backspace, delete, setas e tab
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', '.', 'Tab'];
  if (!((e.key >= '0' && e.key <= '9') || allowedKeys.includes(e.key))) {
    e.preventDefault();
    return;
  }

  // Evitar múltiplos pontos
  if (e.key === '.' && value.includes('.')) {
    e.preventDefault();
    return;
  }

  // Limitar a duas casas decimais usando regex
  const regex = /^\d+(\.\d{0,2})?$/; // Permite números com até duas casas decimais
  const simulatedValue = value + e.key; // Simula o próximo valor com a tecla pressionada

  if (e.key !== 'Backspace' && e.key !== 'Delete' && !regex.test(simulatedValue)) {
    e.preventDefault();
    return;
  }
}

const formatDietGroup = (group) => {
  switch (group) {
    case 'weightLoss':
      return 'Perda de Peso';
    case 'weightGain':
      return 'Ganho de Peso';
    case 'generalHealth':
      return 'Saúde Geral';
    case 'vegetarianLifestyles':
      return 'Estilos Vegetarianos';
    case 'healthSpecific':
      return 'Saúde Específica';
    default:
      return 'Outros';
  }
};


const formatPersonType = (person_type) => {
  switch (person_type) {
    case 'nutritionist':
      return 'Nutricionista';
    case 'doctor':
      return 'Médico';
    case 'professional':
      return 'Profissional';
    default:
      return '';
  }
};

const formatSpeciality = (speciality) => {
  switch (speciality) {
    case 'general_clinic':
      return 'Clinica Geral';
    case 'physiotherapyst':
      return 'Fisioterapia';
    case 'nutritionist':
      return 'Nutrição';
    default:
      return '';
  }
};

const measureUnits = [
  { value: 'g', label: 'g - Gramas' },
  { value: 'kg', label: 'kg - Quilogramas' },
  { value: 'un', label: 'un - Unidades' },
  { value: 'ml', label: 'ml - Mililitros' },
  { value: 'l', label: 'l - Litros' },
  { value: 'soupe_spon', label: 'colher de sopa (15 ml)' },
  { value: 'tea_spon', label: 'colher de chá (5 ml)' },
  { value: 'dessert_spon', label: 'colher de sobremesa (10 ml)' },
  { value: 'cup', label: 'xícara (240 ml)' },
  { value: 'slice', label: 'fatia' },
  { value: 'piece', label: 'peça' },
  { value: 'bottle', label: 'garrafa' },
  { value: 'can', label: 'lata' },
  { value: 'pack', label: 'pacote' },
  { value: 'drop', label: 'gota' },
  { value: 'pinch', label: 'pitada' },
  { value: 'tray', label: 'bandeja' },
  { value: 'bar', label: 'barra' },
  { value: 'box', label: 'caixa' },
];

const availableDiets = {
  weightLoss: [
    { value: 'low_carb', label: 'Dieta Low Carb', objective: 'Reduzir carboidratos para perda de peso.' },
    { value: 'keto', label: 'Dieta Cetogênica', objective: 'Induzir cetose para queima de gordura.' },
    { value: 'caloric_deficit', label: 'Dieta de Déficit Calórico', objective: 'Reduzir calorias para emagrecimento sustentável.' },
    { value: 'intermittent_fasting', label: 'Dieta do Jejum Intermitente', objective: 'Focar em períodos de jejum para regulação metabólica.' },
    { value: '21_day_diet', label: 'Dieta de 21 Dias', objective: 'Plano temporário para perda de peso rápida.' },
    { value: 'detox', label: 'Dieta Detox', objective: 'Eliminação de toxinas e renovação celular.' },
    { value: '7_day_detox', label: 'Dieta Detox de 7 Dias', objective: 'Renovação do corpo com alimentos leves e saudáveis.' },
  ],
  weightGain: [
    { value: 'hypercaloric', label: 'Dieta Hipercalórica', objective: 'Aumentar o consumo calórico para ganho de peso.' },
    { value: 'hypertrophic', label: 'Dieta Hipertófica', objective: 'Foco no ganho de massa muscular e hipertrofia.' },
    { value: 'bulking', label: 'Dieta Bulking', objective: 'Ganho de peso em preparação para hipertrofia.' },
    { value: 'protein_diet', label: 'Dieta da Proteína', objective: 'Aumentar o consumo de proteínas para ganho muscular.' },
    { value: 'lean_gain', label: 'Dieta para Ganho Lean (Massa Magra)', objective: 'Ganho de massa magra com pouca gordura.' },
  ],
  generalHealth: [
    { value: 'mediterranean', label: 'Dieta Mediterrânea', objective: 'Saúde geral baseada na culinária mediterrânea.' },
    { value: 'mediterranean_adapted', label: 'Dieta Mediterrânea Adaptada', objective: 'Promover saúde cardiovascular com alimentos integrais.' },
    { value: 'antiinflammatory', label: 'Dieta Antiinflamatória', objective: 'Reduzir inflamações com alimentos funcionais.' },
    { value: 'antioxidant', label: 'Dieta Antioxidante', objective: 'Melhorar a saúde celular com antioxidantes.' },
    { value: 'high_fiber', label: 'Dieta Rica em Fibras', objective: 'Aumentar a ingestão de fibras para saúde digestiva.' },
    { value: 'cardiovascular', label: 'Dieta de Saúde Cardiovascular', objective: 'Proteger o coração com alimentos saudáveis.' },
    { value: 'immune_boost', label: 'Dieta para Imunidade', objective: 'Fortalecer o sistema imunológico.' },
  ],
  vegetarianLifestyles: [
    { value: 'vegan', label: 'Dieta Vegana', objective: 'Estilo de vida sem consumo de alimentos de origem animal.' },
    { value: 'vegetarian', label: 'Dieta Vegetariana', objective: 'Dieta baseada em vegetais, sem carne.' },
    { value: 'flexitarian', label: 'Dieta Flexitariana', objective: 'Dieta vegetariana com consumo ocasional de carne.' },
    { value: 'pescatarian', label: 'Dieta Pescetariana', objective: 'Dieta vegetariana com inclusão de peixes.' },
    { value: 'paleo', label: 'Dieta Paleo', objective: 'Foco em alimentos naturais e integrais.' },
  ],
  healthSpecific: [
    { value: 'dash', label: 'Dieta DASH (Hipertensão)', objective: 'Reduzir a pressão arterial com alimentos ricos em nutrientes.' },
    { value: 'fodmap', label: 'Dieta FODMAP (Distúrbios Intestinais)', objective: 'Melhorar a digestão e reduzir desconfortos intestinais.' },
    { value: 'diabetes', label: 'Dieta para Diabetes', objective: 'Controlar os níveis de glicose no sangue.' },
    { value: 'low_sodium', label: 'Dieta Hipossódica', objective: 'Reduzir o consumo de sódio para saúde cardiovascular.' },
    { value: 'renal', label: 'Dieta Renal (Insuficiência Renal)', objective: 'Controlar nutrientes para a saúde dos rins.' },
  ],
};


const availableMeals = [
  { value: 'breakfast', label: 'Café da Manhã' },
  { value: 'morning_snack', label: 'Lanche da Manhã' },
  { value: 'lunch', label: 'Almoço' },
  { value: 'afternoon_snack', label: 'Lanche da Tarde' },
  { value: 'dinner', label: 'Jantar' },
  { value: 'supper', label: 'Ceia' },
];

const availableJustifications = [
  { value: 'diabetes', label: 'Diabetes' },
  { value: 'hypertension', label: 'Hipertensão' },
  { value: 'obesity', label: 'Obesidade' },
  { value: 'pregnancy', label: 'Gestação' },
  { value: 'lactation', label: 'Lactação' },
  { value: 'childhood', label: 'Infância' },
  { value: 'prescription', label: 'Medicação' },
  { value: 'illness', label: 'Doença' },
];

const availableDietTypes = [
  { value: 'regular', label: 'Dieta Regular' },
  { value: 'complementation', label: 'Dieta Complementar' },
  { value: 'competition', label: 'Dieta Treino Profissinal' },
  { value: 'exercise', label: 'Exercício' },
];

// Tabela de equivalências
const unitConversions = {
  "ml": 1, "l": 1000, "g": 1, "kg": 1000,
  "colher de sopa": 15, "colher de chá": 5, "xícara": 240,
  "fatia": 50, "un": 100, "garrafa": 500, "lata": 350,
};

const convertToBaseUnit = (quantity, unit) => {
  const conversionFactor = unitConversions[unit] || 1;
  return quantity * conversionFactor;
};

const calculateMealCalories = (foods) => {
  return foods.reduce((total, food) => {
    const quantity = parseFloat(food.quantity) || 0;
    const kcalPer100g = parseFloat(food.kcal) || 0;
    const equivalentValue = parseFloat(food.equivalent_value) || 1;

    // Converte a quantidade usando a equivalência fornecida (ex: 1 unidade = 50g)
    const quantityInGrams = (quantity * equivalentValue);

    return total + (quantityInGrams * kcalPer100g) / 100;
  }, 0);
};



const selectOptions = (items, labelKey = 'name') => items.map(item => ({
  value: item.person_id || item.company_id,
  label: item[labelKey],
}));


// Adicione esta função no seu componente
const getMostRecentDiet = (diets) => {
  if (!Array.isArray(diets)) return null;

  // Ordena as dietas por data de criação (da mais recente para a mais antiga)
  const sortedDiets = [...diets].sort((a, b) =>
    new Date(b.created_at) - new Date(a.created_at)
  );

  return sortedDiets[0] || null;
};
function formatGender(gender) {
  switch (gender) {
    case 'female':
      return 'Feminino';
    case 'male':
      return 'Masculino';
    case 'others':
      return 'Outros';
    default:
      return 'Não especificado';
  }
};

const categoryOptions = [
  { value: 'household', label: 'Medida Caseira' },
  { value: 'standard', label: 'Medida Padrão' },
  { value: 'international', label: 'Internacional' },
  { value: 'packing', label: 'Embalagem' },
  { value: 'whole_food', label: 'Unidade Inteira' },
  { value: 'meat_cuts', label: 'Cortes de Carne' },
  { value: 'custom', label: 'Outros (especificar)' }
];

const formatUnityMesasurementCategory = (value) => {
  switch (value) {
    case 'household': return 'Medida Caseira';
    case 'standard': return 'Medida Padrão';
    case 'international': return 'Internacional';
    case 'packing': return 'Embalagem';
    case 'whole_food': return 'Unidade Inteira';
    case 'meat_cuts': return 'Cortes de Carne';
    case 'custom': return 'Outro';
    default: return value; // ← aqui usamos o valor literal se for personalizado
  }
};



module.exports = {
  onlyNumbers,
  formatDietGroup,
  formatPersonType,
  formatSpeciality,
  measureUnits,
  availableDiets,
  availableMeals,
  availableJustifications,
  availableDietTypes,
  unitConversions,
  convertToBaseUnit,
  calculateMealCalories,
  selectOptions,
  getMostRecentDiet,
  formatGender,
  formatUnityMesasurementCategory,
  categoryOptions,
}